export default "__VITE_ASSET__7cefe34f__"